<template>
  <!-- 跳转linkein -->
  <el-dialog
    title="即将离开海智智造"
    :visible.sync="visible"
    width="660px"
    custom-class="linKInDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div style="line-height: 48px">
      <span
        style="
          display: block;
          color: #ff7f2aff;
          font-size: 16px;
          font-face: SourceHanSansCN;
          font-weight: 400;
        "
      >
        {{ message }}</span
      >
      <div class="url-content">{{ linkinUrl }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="confirm" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('linkedin', ['linkinUrl', 'message']),
    visible: {
      get() {
        return this.$store.state.linkedin.visible
      },
      set(val) {
        this.SET_VISIBLE(val)
      },
    },
  },
  methods: {
    ...mapMutations('linkedin', ['SET_VISIBLE']),
    // 确定跳转linkin
    confirm() {
      this.SET_VISIBLE(false)
      let url = this.linkinUrl
      // 判断当前网址有没有包含协议前缀，如果没有，拼接 //
      if (!/^(http|https):\/\//i.test(url)) {
        url = '//' + url
      }
      window.open(url)
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .linKInDialog {
    .el-dialog__body {
      padding: 0 32px;

    }
    .el-dialog__header {
      padding: 32px;
      padding-bottom: 10px;
      .el-dialog__headerbtn {
        right: 32px;
      }
    }
    .el-dialog__footer {
      padding: 32px;
    }
    .url-content {
      line-height: 20px;
    }
  }
  
</style>